
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export const FacebookCallback = () => {
  const navigate = useNavigate();
  const { toast } = useToast();

  useEffect(() => {
    const handleFacebookCallback = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const state = urlParams.get('state');
        const error = urlParams.get('error');
        const error_description = urlParams.get('error_description');

        if (error) {
          console.error('Facebook OAuth error:', error, error_description);
          toast({
            title: "Facebook Connection Failed",
            description: error_description || error,
            variant: "destructive"
          });
          navigate('/profile');
          return;
        }

        if (!code || !state) {
          throw new Error('Missing authorization code or state');
        }

        // Call the Facebook OAuth edge function to complete the process
        const { data, error: functionError } = await supabase.functions.invoke('facebook-oauth', {
          body: {
            action: 'exchange_code',
            code,
            state,
            redirect_uri: `${window.location.origin}/auth/facebook/callback`
          }
        });

        if (functionError) {
          throw functionError;
        }

        toast({
          title: "Success",
          description: "Facebook account connected successfully!",
        });

        navigate('/profile?facebook_connected=true');
      } catch (error) {
        console.error('Facebook callback error:', error);
        toast({
          title: "Connection Failed",
          description: "Failed to complete Facebook connection",
          variant: "destructive"
        });
        navigate('/profile');
      }
    };

    handleFacebookCallback();
  }, [navigate, toast]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h2 className="text-xl font-semibold mb-2">Connecting to Facebook...</h2>
        <p className="text-gray-600">Please wait while we complete the connection.</p>
      </div>
    </div>
  );
};
